import gql from 'graphql-tag';

const GET_MATERIAL =  gql`
  query GetMystageMaterials($b: Int!, $test: Int!) {
    mystage_get_materials(b: $b, test: $test) {
      ri
      lv
      rk
      rt
      mt
      ls {
        li
        ln
        lc
        lt
        ti
        vi
        mi
        hh
        rv
      }
    }
  }
`;
const GET_MATERIAL_MSB =  gql`
  query GetMystageMaterials($b: Int!, $test: Int!) {
    getMaterials(b: $b, test: $test) {
      ri
      lv
      rk
      rt
      mt
      rv
      ls {
        li
        ln
        lc
        lt
        ti
        vi
        mi
        hh
        rv
      }
    }
  }
`;

const GET_PDF = gql`
  query GetPdf($b: Int!, $m: Int!, $dl: Int!) {
    get_pdf(b: $b, m: $m, dl: $dl) {
      id
      type
      url
    }
  }
`;

const GET_PDF_MSB = gql`
  query GetPdf($b: Int!, $m: Int!, $dl: Int!) {
    getPdf(b: $b, m: $m, dl: $dl) {
      id
      type
      url
    }
  }
`;


const GET_TEST_PDF_MSB = gql`
  query GetPdf($b: Int!, $m: Int!, $dl: Int!) {
    getPdf: getTestPdf(b: $b, m: $m, dl: $dl) {
      id
      type
      url
    }
  }
`;

const GET_HTML = gql`
  query getHtml($l: Int!, $r: Int!, $b: Int, $sm: Int, $p: Int, $rv: Int) {
    get_html(l: $l, r: $r, b: $b, sm: $sm, p: $p, rv: $rv) {
      id
      program_id
      level_id
      rank_id
      lesson_id
      code
      no
      title
      program
      level
      rank
      css
      content
      pdf_url
      html_url
      is_revamp
      admin
    }
  }`;
  
const GET_HTML_MSB = gql`
  query getHtml($l: Int!, $r: Int!, $b: Int, $sm: Int, $p: Int, $rv: Int, $hv: Int, $s: Int) {
    getHtml(l: $l, r: $r, b: $b, sm: $sm, p: $p, rv: $rv, hv: $hv, s: $s) {
      id
      program_id
      level_id
      rank_id
      lesson_id
      code
      no
      title
      program
      level
      rank
      css
      content
      pdf_url
      html_url
      is_revamp
      admin
      user_role_code
      contract_type
    }
  }`;

// `GET_TRAINER_HTML` doesnt exist, since this endpoint was NOT migrated to GraphQL.
// this is just a variable naming convention to match the MBTI service.
const GET_TRAINER_HTML_MSB = gql`
  query GetTrainerHtmlMaterial($r: Int!, $p: Int!) {
    trainerHtmlMaterial(r: $r, p: $p) {
      id
      program_id
      level_id
      rank_id
      lesson_id
      no
      title
      level
      rank
      html
      css
      html_zip
    }
  }`;

// `GET_USER_TYPE_HTML` doesnt exist, since this endpoint was NOT migrated to GraphQL.
// this is just a variable naming convention to match the MBTI service.
// this is the general use endpoint, see [mystage-frontend]src/router.js->HtmlMaterial (component) for the user type material URL specific endpoint.
const GET_USER_TYPE_HTML_MSB = gql`
  query GetUserHtmlMaterial($r: Int!, $l: Int!, $rv: Int) {
    userHtmlMaterial(r: $r, l: $l, rv: $rv) {
      id
      program_id
      level_id
      rank_id
      lesson_id
      code
      no
      title
      program
      level
      rank
      css
      content
      pdf_url
      html_url
      is_revamp
    }
  }`;

export { 
  GET_MATERIAL, 
  GET_PDF, 
  GET_HTML,
  GET_MATERIAL_MSB,
  GET_PDF_MSB,
  GET_HTML_MSB,
  GET_TRAINER_HTML_MSB,
  GET_USER_TYPE_HTML_MSB,
  GET_TEST_PDF_MSB
};
